import { render, staticRenderFns } from "./PartnershipDetails.vue?vue&type=template&id=60a0f8b4&"
import script from "./PartnershipDetails.vue?vue&type=script&lang=js&"
export * from "./PartnershipDetails.vue?vue&type=script&lang=js&"
import style0 from "./PartnershipDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports